import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {WORK_URLS, URL_PARAMS, DISP_MODE} from "../../../../constants/constants";

export interface WorkDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  classId: string,
}

export function WorkDetailDialog(props: WorkDetailDialogProps) {
  // console.log('Work Detail Dialog', props.classId);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='対象物詳細' src={`${WORK_URLS.WORK_DETAIL.URL}/${props.classId}?${URL_PARAMS.DISP_MODE}=${DISP_MODE.POPUP}`}/>
  )
}
